import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ApplicationsDialog = ({ open, onClose, applications }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        Заявки ({applications?.length ?? 0})
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {!applications?.length ? (
          <Typography>Нет заявок</Typography>
        ) : (
          <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>БИН поставщика</TableCell>
                  <TableCell>Статус заявки</TableCell>
                  <TableCell align="right">Сумма заявки</TableCell>
                  <TableCell align="right">Цена за ед</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {applications.map((app, index) => (
                  <TableRow key={`${app.applicantId}-${index}`}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{app.supplierIdentifier ?? "N/A"}</TableCell>
                    <TableCell>{app.statusNameRu ?? "N/A"}</TableCell>
                    <TableCell align="right">
                      {app.amount ?? "N/A"}
                    </TableCell>
                    <TableCell align="right">
                      {app.price ?? "N/A"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Закрыть</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApplicationsDialog;